import { getAuthHeader, getUserInfo } from '../utils/tokenManager';

const API_BASE_URL = 'https://trpliveapi1.tripbox.co.kr';
const EMAIL_API_URL = 'https://revato.mytripbox.co.kr/itinerary/send-email';

// Save company SMTP settings (발신메일/SMTP 설정 저장)
// SP: DBO.WSP_T_%ED%9A%8C%EC%82%AC_SMTP%EC%A0%95%EB%B3%B4%EB%93%B1%EB%A1%9D
// payload Table1:
//   @업체번호, @SMTP주소, @SMTP포트, @SMTP아이디(base64), @SMTP비밀번호(base64), @SMTP보안연결(boolean), @SMTP업체
export const saveCompanySmtpSettings = async ({ smtpHost, smtpPort, smtpIdBase64, smtpPasswordBase64, secure = true, providerKey }) => {
  const { companyNo } = getUserInfo() || {};
  const payload = {
    Table1: [
      { 컬럼명: '@업체번호', 값: String(companyNo) },
      { 컬럼명: '@SMTP주소', 값: String(smtpHost || '') },
      { 컬럼명: '@SMTP포트', 값: String(smtpPort || '') },
      { 컬럼명: '@SMTP아이디', 값: String(smtpIdBase64 || '') },
      { 컬럼명: '@SMTP비밀번호', 값: String(smtpPasswordBase64 || '') },
      { 컬럼명: '@SMTP보안연결', 값: !!secure },
      { 컬럼명: '@SMTP업체', 값: String(providerKey || 'custom') },
    ],
  };
  const url = `${API_BASE_URL}/ERP/GetDataSet?procedureName=DBO.WSP_T_%ED%9A%8C%EC%82%AC_SMTP%EC%A0%95%EB%B3%B4%EB%93%B1%EB%A1%9D`;
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw new Error(`API error: ${response.status}`);
  const data = await response.json().catch(() => ({}));
  return data;
};

// Get existing company SMTP settings
// SP: DBO.WSP_S_%ED%9A%8C%EC%82%ACSMTP%EC%A0%95%EB%B3%B4
// payload Table1: @업체번호
export const getCompanySmtpSettings = async () => {
  const { companyNo } = getUserInfo() || {};
  const payload = {
    Table1: [
      { 컬럼명: '@업체번호', 값: String(companyNo) },
    ],
  };
  const url = `${API_BASE_URL}/ERP/GetDataSet?procedureName=DBO.WSP_S_%ED%9A%8C%EC%82%ACSMTP%EC%A0%95%EB%B3%B4`;
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`API error: ${res.status}`);
  const data = await res.json().catch(() => ({}));
  const table = Array.isArray(data?.table) ? data.table : Array.isArray(data?.Table) ? data.Table : [];
  return table && table.length ? table[0] : null;
};

// Send email via external API
// Endpoint: https://revato.mytripbox.co.kr/itinerary/send-email
// Payload: { recipients: string[], subject: string, body: string, smtp_server: string, smtp_port: number, smtp_username: string (base64), smtp_password: string (base64) }
export const sendEmail = async ({ recipients, subject, body, smtpServer, smtpPort, smtpUsername, smtpPassword }) => {
  const payload = {
    recipients: Array.isArray(recipients) ? recipients : [recipients],
    subject: String(subject || ''),
    body: String(body || ''),
    is_html: true,
    content_type: 'text/html',
    smtp_server: String(smtpServer || ''),
    smtp_port: Number(smtpPort) || 465,
    smtp_username: String(smtpUsername || ''),
    smtp_password: String(smtpPassword || ''),
  };
  const response = await fetch(EMAIL_API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const errorText = await response.text().catch(() => '');
    throw new Error(`이메일 발송 실패: ${response.status} ${errorText}`);
  }
  const data = await response.json().catch(() => ({}));
  return data;
};

